import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import ApartmentFields from './ApartmentFields'

export const ApartmentEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <ApartmentFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default ApartmentEdit
